import errors from "./errors";
import translations from "./translations";
import help from "./help";

export default {...errors, ...translations, ...help}